import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=0c393f4e&scoped=true&"
import script from "./UserPhoto.vue?vue&type=script&lang=js&"
export * from "./UserPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoto.vue?vue&type=style&index=0&id=0c393f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c393f4e",
  null
  
)

export default component.exports